<div class="bmc-automation-detail-wrapper"
  *ngIf="!(isLoading$ | async) && automationConnection$ | async as automationConnection">
  <bot-configuration #botConfiguration [botDetail]="automationConnection" (save)="onSave($event)"
    [type]="'automationAnywhere'" (testConnection)="onTestConnection(automationConnection)">
  </bot-configuration>
  <hr class="bmc-bot-detail-wrapper__horizontal-rule">
</div>
<div class="bmc-automation-detail-wrapper__loading-container" *ngIf="(isLoading$ | async)">
  <bzg-loading *ngIf="(isLoading$ | async)" [size]="'s'" class="bmc-automation-detail-wrapper__loading">
    {{'GLOBAL.LOADING_DATA' | translate}}
  </bzg-loading>
</div>

<bots-empty *ngIf="!(automationConnection$ | async) && !(isLoading$ | async)">
  {{'RPA_BOTS.EMPTY_DETAIL' | translate}}
</bots-empty>